// Explicit label for every default class, so nothing relies on an unlisted name
// happening to already look right. Custom classes have no entry and fall through
// to their raw name.
const DataClassLabels: Record<string, string> = {
  PII: 'PII',
  FI: 'FI',
  PHI: 'PHI',
  CREDENTIALS: 'Credentials',
};

export const dataClassLabel = (name: string) => DataClassLabels[name] ?? name;
